
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { MissionHubHeader } from '@/components/mission-hub/MissionHubHeader';
import { usePoints } from '@/hooks/missionhub/points';
import { useTranslation } from '@/hooks/support/translate';
import { appPointsAtom } from '@/state/app';
import { getLeaderboard } from '@/utils/http/get-leaderboard';
import { InferGetServerSidePropsType } from 'next';
import Head from 'next/head';
import Image from 'next/image';
import { useRecoilValue } from 'recoil';

const MissionHubLeaderboard = ({ leaderboard }: InferGetServerSidePropsType<typeof getStaticProps>) => {
    const { t } = useTranslation();
    usePoints();
    const { standingData } = useRecoilValue(appPointsAtom);

    const RankCell = (rank: number) => {
        const medalImages = [
            '/images/icon__medal-gold.svg',
            '/images/icon__medal-silver.svg',
            '/images/icon__medal-bronze.svg',
        ];
        const imageSrc = rank > 2 ? null : medalImages[rank];
        return rank > 2 ? (
            <span className="px-4 text-lg font-bold">{rank + 1}</span>
        ) : (
            <div>
                <Image alt="Rank" src={imageSrc!} width={40} height={40} />
            </div>
        );
    };
    return (
        <>
            <Head>
                <title>ClayStack | Mission Hub - Leaderboard</title>
            </Head>
            <div className="fixed top-8 right-0 2xl:right-[5%] z-[-1] w-full h-full">
                <div className="gr--blue">
                    <div className="gr--red"></div>
                </div>
            </div>
            <div className="container px-4 pt-12 mx-auto md:px-32">
                <MissionHubHeader
                    className="mb-8"
                    title="Leaderboard"
                    actions={
                        <div className="flex flex-col items-center justify-center">
                            <span className="text-white t__heading--h5">{standingData.ranking ?? 0}</span>
                            <span className="mt-2 t__subtitle--s2 text-grey-20">Your rank</span>
                        </div>
                    }
                />
                <div className="leaderboard-table">
                    <div className="flex leaderboard-header">
                        <span>{t('modal.pointsSystem.leaderboard.table.rank')}</span>
                        <span className="ml-12 md:ml-28">
                            {t('modal.pointsSystem.leaderboard.table.walletAddress')}
                        </span>
                        <span className="ml-auto">{t('modal.pointsSystem.leaderboard.table.totalPoints')}</span>
                    </div>
                    <div className="pb-12 leaderboard-body">
                        {leaderboard.slice(0, 50).map((item, index) => (
                            <div className="relative flex items-center justify-between w-full" key={index}>
                                <span className="mr-8 md:mr-24">{RankCell(index)}</span>
                                <span className="mr-auto">{item._id.toUpperCase()}</span>
                                <span className="px-4 py-2 ml-auto mr-4 text-white rounded-lg t__heading--h6 bg-pink-80">
                                    {Math.round(item.total_points)}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

 const _getStaticProps = async () => {
    const leaderboard = await getLeaderboard();
    return {
        props: {
            leaderboard,
            refreshTimestamp: Date.now(),
            revalidate: 60 * 5, // 5 mins
        },
    };
};

export default MissionHubLeaderboard;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/mission-hub/leaderboard',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  